export const submissionMethodOptions = [
  { label: 'Online Portal', value: 'online_portal' },
  { label: 'Mail/Fax', value: 'mail/fax' },
  { label: 'Email', value: 'email' },
];

export const statusOptions = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];

export const waterAuthorityFormFields = [
  {
    name: 'name',
    kind: 'text',
    createOnly: true,
  },
  {
    name: 'contact_email',
    kind: 'text',
  },
  {
    name: 'online_portal_url',
    kind: 'text',
  },
  {
    name: 'submission_method',
    kind: 'select',
    choices: submissionMethodOptions,
  },
  {
    name: 'status',
    kind: 'select',
    choices: statusOptions,
  },
  {
    name: 'requires_account_number',
    kind: 'toggle',
    onLabel: 'Yes',
    offLabel: 'No',
    xs: 6,
  },
  {
    name: 'requires_service_number',
    kind: 'toggle',
    onLabel: 'Yes',
    offLabel: 'No',
    xs: 6,
  },
];
